import { Grid } from '@optimus-web/core';

export const ResponsiveTwoColumnsFormFields = ({ children }: React.PropsWithChildren<{}>) => (
    <Grid
        columnGap="100"
        templateColumns="minmax(0, 1fr) minmax(0, 1fr)"
        largePhoneMax={{ templateColumns: 'minmax(0, 1fr)' }}
    >
        {children}
    </Grid>
);
